import { RestfulFetchOptions } from "@type-r/endpoints";
import { getAuthToken, getGeneralPlatformCode } from "api/embedded-auth";
import { RestfulEndpoint } from "api/endpoint";


export function restfulIO(path: string, fetchOptions?: Partial<RestfulFetchOptions>) {
    return new RestfulEndpoint(path, fetchOptions, getAuthToken, getGeneralPlatformCode);
}

export function getB2CToken() {
    //return localStorage.getItem('b2c_access_token');
    return getAuthToken();
}

export function getAuthorizationBearer() {
    return "Bearer " + getAuthToken();
}

export function getPlatformCode() {
    return getGeneralPlatformCode();
}
